import { CommApiInstance } from "Utils/CommApiInstance";

export interface CommuBrdCmntRegApiResponse {
    apiHdr: {
        code: string;
        msg: string;
        respDtime: string;
        rqstTrxId: string;
        rqstDtime: string;
        lang: string;
        timeZone: string;
    };
    apiBody: {
        yn: string;
        appYn: string;
    };
}

const CommuBrdCmntRegApi = async (
    brdCd:string,
    brdPstdSno:string,
    cmntCtxt:string,
    cptchTkn:string
) : Promise<CommuBrdCmntRegApiResponse> => {
    return await CommApiInstance.post(`brd/BBO/${brdCd}/${brdPstdSno}/reg`,{
        apiBody:{
            cmntCtxt: cmntCtxt,
            cptchTkn: cptchTkn
        }
    })
    .then((Resp) => Resp.data as CommuBrdCmntRegApiResponse);
}
export default CommuBrdCmntRegApi;